import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/pPx98bwU3vHGpQXDqZtSXg/photo_2026-04-15_15-31-08.jpg',
  title: 'Para desconectar',
  text: 'Espacios donde el tiempo se siente distinto.'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/8rZ3dhGvWywgoxXL5PHG7W/photo_2026-04-15_15-30-34.jpg',
  title: 'Para compartir',
  text: 'Ambientes amplios pensados para disfrutar en familia.'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/aQUQ2s6ypme4XvAzk4AfeU/photo_2026-04-15_15-31-31.jpg',
  title: 'Para descansar',
  text: 'Tranquilidad real, sin interrupciones ni ruido.'
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/ny7uddp5upefn8FqQEMHBv/photo_2026-02-18_11-31-52.jpg',
  title: 'Para contemplar',
  text: 'La belleza de lo simple y natural.'
}];
export function EstanciaCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [isHovered]);
  const handleDragEnd = (e: any, {
    offset,
    velocity
  }: any) => {
    const swipe = offset.x;
    if (swipe < -50) {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % slides.length);
    } else if (swipe > 50) {
      setDirection(-1);
      setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
    }
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? '5%' : '-5%',
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? '5%' : '-5%',
      opacity: 0
    })
  };
  return <div className="relative w-full overflow-hidden mt-12 md:mt-20 bg-[#FAF8F5] px-0" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-52">
      <div className="relative w-full h-[55vh] md:h-[75vh] rounded border-[5px] border-white/90 shadow-[0_2px_20px_rgba(0,0,0,0.06)] overflow-hidden" data-id="element-53">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-54">
          <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
          x: {
            type: 'spring',
            stiffness: 200,
            damping: 40,
            mass: 1
          },
          opacity: {
            duration: 1.5,
            ease: [0.25, 0.1, 0.25, 1]
          }
        }} className="absolute inset-0 w-full h-full cursor-grab active:cursor-grabbing" drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.8} onDragEnd={handleDragEnd} data-id="element-55">
            <motion.img src={slides[currentIndex].image} alt={slides[currentIndex].title} initial={{
            scale: 1.05
          }} animate={{
            scale: 1
          }} transition={{
            duration: 10,
            ease: 'easeOut'
          }} className="w-full h-full object-cover pointer-events-none" data-id="element-56" />
          </motion.div>
        </AnimatePresence>

        {/* Indicators */}
        <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 flex space-x-4 z-10" data-id="element-57">
          {slides.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > currentIndex ? 1 : -1);
          setCurrentIndex(idx);
        }} className={`h-[1px] transition-all duration-700 ease-in-out ${idx === currentIndex ? 'w-12 bg-white' : 'w-6 bg-white/30 hover:bg-white/60'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-58" />)}
        </div>
      </div>

      {/* Text below image */}
      <div className="px-6 md:px-16 lg:px-24 pt-8 pb-2" data-id="element-59">
        <AnimatePresence mode="wait" data-id="element-60">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-61">
            <h3 className="md:text-4xl lg:text-5xl text-[#2C2420] mb-3 font-[Inter,_sans-serif] font-[300] text-[18px]" data-id="element-62">
              {slides[currentIndex].title}
            </h3>
            <p className="font-sans text-sm md:text-base text-[#2C2420]/60 max-w-md font-light tracking-wide" data-id="element-63">
              {slides[currentIndex].text}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}